import { AllBrandsProductListingConstants } from '../constants';

export function AllBrandsProductListingReducer(state = {}, action) {
    switch (action.type) {
        case AllBrandsProductListingConstants.GET_ALL_BRANDS_PRODUCTS_REQUEST:
            return {
                loading: true
            };
        case AllBrandsProductListingConstants.GET_ALL_BRANDS_PRODUCTS_SUCCESS:
            // return [...state, action.allProductIds];
            return {
                items: action.productListing,
                loading:false
            };
        case AllBrandsProductListingConstants.GET_ALL_BRANDS_PRODUCTS_FAILURE:
            return {
                error: action.error
            };
        default:
            return state
    }
}